<template>
  <div>
    <div class="mb-4">
      <label for="">{{ 'Header' | translate }}</label>
      <input
        class="form-control"
        type="text"
        v-model="block.header"
        :placeholder="$t('Header')"
        maxlength="200"
      />
    </div>
    <div class="mb-3">
      <label for="">{{ 'Buy button' | translate }} - CTA</label>
      <input
        class="form-control"
        type="text"
        v-model="settings.buy_button_text"
        maxlength="200"
      />
    </div>

    <div class="mb-3">
      <div class="form-check">
        <input v-model="settings.buy_button_hide_price" value="1" class="form-check-input" type="checkbox" :id="`hideprice${block.id}`">
        <label class="form-check-label" :for="`hideprice${block.id}`">
          {{'Hide price' | translate}}
        </label>
      </div>      
    </div>

    <div class="mb-4">
      <label for="">{{ 'Buy button' | translate }} - {{'color' | translate}}</label>
      <select v-model="settings.buy_button_color" class="form-select">
        <option value="">Default</option>
        <option value="btn-primary">{{'Blue' | translate}}</option>
        <option value="btn-outline-primary">{{'Blue' | translate}} {{'outline' | translate}}</option>
        <option value="btn-secondary">{{'Grey' | translate}}</option>
        <option value="btn-outline-secondary">{{'Grey' | translate}} {{'outline' | translate}}</option>
        <option value="btn-light">{{'Light' | translate}}</option>
        <option value="btn-outline-light">{{'Light' | translate}} {{'outline' | translate}}</option>
        <option value="btn-dark">{{'Dark' | translate}}</option>
        <option value="btn-outline-dark">{{'Dark' | translate}} {{'outline' | translate}}</option>
        <option value="btn-info">{{'Cyan' | translate}}</option>
        <option value="btn-outline-info">{{'Cyan' | translate}} {{'outline' | translate}}</option>
        <option value="btn-warning">{{'Yellow' | translate}}</option>
        <option value="btn-outline-warning">{{'Yellow' | translate}} {{'outline' | translate}}</option>
        <option value="btn-danger">{{'Red' | translate}}</option>
        <option value="btn-outline-danger">{{'Red' | translate}} {{'outline' | translate}}</option>
        <option value="btn-success">{{'Green' | translate}}</option>
        <option value="btn-outline-success">{{'Green' | translate}} {{'outline' | translate}}</option>
        <option value="btn-indigo">{{'Indigo' | translate}}</option>
        <option value="btn-outline-indigo">{{'Indigo' | translate}} {{'outline' | translate}}</option>
        <option value="btn-pink">{{'Pink' | translate}}</option>
        <option value="btn-outline-pink">{{'Pink' | translate}} {{'outline' | translate}}</option>
        <option value="btn-purple">{{'Purple' | translate}}</option>
        <option value="btn-outline-purple">{{'Purple' | translate}} {{'outline' | translate}}</option>
        <option value="btn-teal">{{'Teal' | translate}}</option>
        <option value="btn-outline-teal">{{'Teal' | translate}} {{'outline' | translate}}</option>
      </select>
    </div>
    <div class="mb-3">
      <label for="">{{ 'Subscribe button' | translate }} - CTA</label>
      <input
        class="form-control"
        type="text"
        v-model="settings.subscribe_button_text"
        maxlength="200"
      />
    </div>
    <div class="mb-3">
      <label for="">{{ 'Subscribe button' | translate }} - {{'color' | translate}}</label>
      <select v-model="settings.subscribe_button_color" class="form-select">
        <option value="">Default</option>
        <option value="btn-primary">{{'Blue' | translate}}</option>
        <option value="btn-outline-primary">{{'Blue' | translate}} {{'outline' | translate}}</option>
        <option value="btn-secondary">{{'Grey' | translate}}</option>
        <option value="btn-outline-secondary">{{'Grey' | translate}} {{'outline' | translate}}</option>
        <option value="btn-light">{{'Light' | translate}}</option>
        <option value="btn-outline-light">{{'Light' | translate}} {{'outline' | translate}}</option>
        <option value="btn-dark">{{'Dark' | translate}}</option>
        <option value="btn-outline-dark">{{'Dark' | translate}} {{'outline' | translate}}</option>
        <option value="btn-info">{{'Cyan' | translate}}</option>
        <option value="btn-outline-info">{{'Cyan' | translate}} {{'outline' | translate}}</option>
        <option value="btn-warning">{{'Yellow' | translate}}</option>
        <option value="btn-outline-warning">{{'Yellow' | translate}} {{'outline' | translate}}</option>
        <option value="btn-danger">{{'Red' | translate}}</option>
        <option value="btn-outline-danger">{{'Red' | translate}} {{'outline' | translate}}</option>
        <option value="btn-success">{{'Green' | translate}}</option>
        <option value="btn-outline-success">{{'Green' | translate}} {{'outline' | translate}}</option>
        <option value="btn-indigo">{{'Indigo' | translate}}</option>
        <option value="btn-outline-indigo">{{'Indigo' | translate}} {{'outline' | translate}}</option>
        <option value="btn-pink">{{'Pink' | translate}}</option>
        <option value="btn-outline-pink">{{'Pink' | translate}} {{'outline' | translate}}</option>
        <option value="btn-purple">{{'Purple' | translate}}</option>
        <option value="btn-outline-purple">{{'Purple' | translate}} {{'outline' | translate}}</option>
        <option value="btn-teal">{{'Teal' | translate}}</option>
        <option value="btn-outline-teal">{{'Teal' | translate}} {{'outline' | translate}}</option>
      </select>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: ['block'],
  data() {
    return {
      settings: {
        buy_button_text: '',
        buy_button_hide_price: '',
        buy_button_color: '',
        subscribe_button_text: '',
        subscribe_button_color: '',
      },
    }
  },
  updated() {
    this.$set(
      this.block,
      'settings',
      _(this.settings).omitBy(_.isNil).omitBy((item) => _.includes(['', false], item)).value(),
    )
  },
  mounted() {
    let block_settings = _.get(this, 'block.settings', {})
    this.settings = { ...this.settings, ...block_settings }
  },
}
</script>
